import type { Statement } from '@gonfalon/audit-log/types';
import { useChangeHistory } from '@gonfalon/change-history/useChangeHistory';
import { enableChangeHistory } from '@gonfalon/dogfood-flags/dogfood-flags';
import { IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { useProjectEntityActionTooltipPlacement } from '../../ProjectEntityLayout/ProjectEntityLayout';

interface ChangeHistoryTriggerProps {
  onPress?: () => void;
  policy?: Statement[];
}

export function ChangeHistoryTrigger({ onPress, policy }: ChangeHistoryTriggerProps) {
  const { hasRouteSpec, open } = useChangeHistory();
  const tooltipPlacement = useProjectEntityActionTooltipPlacement();

  if (!hasRouteSpec) {
    return null;
  }

  const handleOpen = () => {
    open({
      policy,
    });

    onPress?.();
  };

  if (!enableChangeHistory()) {
    return null;
  }

  return (
    <TooltipTrigger>
      <IconButton
        onPress={handleOpen}
        size="medium"
        variant="minimal"
        aria-label="Show change history"
        icon="clock-history"
      />
      <Tooltip placement={tooltipPlacement}>Show change history</Tooltip>
    </TooltipTrigger>
  );
}
